import { render } from "./BioComponent.vue?vue&type=template&id=afeac440"
const script = {}

import exportComponent from "C:\\Folders\\Frontend\\Projects\\dniils.github\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__